import React from 'react'
import styled from '@emotion/styled'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { pushGtmData } from '@jelly/utils'

// Import Components
import { SubHubHeader } from './SubHubHeader'

// Styled Components via Emotion
const useStyles = () =>
	makeStyles(
		(theme) => {
			return {
				HeaderBannerContainer: {
					position: 'relative',
					height: 'auto',
					width: '100%',
					[theme.breakpoints.up('lg')]: {
						zIndex: 1,
					},
					'& *': {
						boxSizing: 'border-box',
					},
					'&.isAbsolute': {
						position: 'absolute',
					},
				},
			}
		},
		{ name: 'headerBanner' }
	)

export const ElementIcon = styled.li`
	list-style-type: none;
	position: relative;
	margin-right: 1rem;

	${({ theme }) => theme.MQ.XS} {
		align-items: center;
		display: flex;
		margin-right: 1.5rem;
	}
`

export const trackNavEvent = ({ destination, type }) => {
	// make sure destination doesn't have leading or trailing slashes - normalize them
	pushGtmData({
		event: 'gaEvent',
		gaEventCategory: 'Site Nav Click',
		gaEventAction: type,
		gaEventLabel: destination.replace(/^\/+/, '').replace(/\/+$/, ''),
		gaEventNoninteraction: false,
	})
}

/**
 * This is the Header Banner App Component
 *
 * @param {Boolean} props.isAbsolute :: determines if the header should be absolute
 * @param {Object} props.classes :: mui theme object
 * @param {Boolean} props.isOverlappingHero :: determines if the navigation links are overlapping the hero image
 * TODO: these will both be deprecated after the new header is rolled out
 *
 */
export function HeaderBanner({ isOverlappingHero = false }) {
	const classes = useStyles({})()

	const HeaderBannerComponent = SubHubHeader
	return (
		<header
			className={clsx({
				[classes.HeaderBannerContainer]: classes.HeaderBannerContainer,
				inverse: !isOverlappingHero,
			})}
		>
			<HeaderBannerComponent isOverlappingHero={isOverlappingHero} />
		</header>
	)
}
